import { Plus as PlusIcon } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

type Props = {
  children?: React.ReactNode
  /** The plus at the bottom of the page: a new symbol goes to this list. */
  onAdd: () => void
}

/**
 * The "Page" frame of the symbols tab: the same box, hint and plus for the
 * project symbols and for the workspace library.
 */
export const SymbolsPage: React.FC<Props> = ({ children, onAdd }) => (
  <div className={css.container}>
    <div className={css.description}>
      Drag symbols into pages on the artboard.
    </div>

    <div className={css.page}>
      <div className={css.page_title}>Page</div>
      <div className={css.symbols}>
        <div>{children}</div>

        <div className={css.new} onClick={onAdd}>
          <PlusIcon className={css.plus_icon} />
        </div>
      </div>
    </div>
  </div>
)
